import React from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = document.getElementById('root');

if (root.hasChildNodes()) {
  // มี HTML ที่ถูก pre-render มาแล้ว เช่นจาก react-snap
  hydrateRoot(root, <App />);
} else {
  // ไม่มี pre-rendered HTML
  createRoot(root).render(<App />);
}

reportWebVitals();